module.exports = __webpack_public_path__ + "img/loginbg.6e7215f7.png";